import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { FAQ_ID_ACCOUNT_CREATION } from '../../../constants';

import LocalizedNavLink from '../../router/LocalizedNavLink';

import './AccountHelpComponent.scss';

// Lien vers la question FAQ « Je n'arrive pas à créer mon compte »
const AccountHelpComponent = ({ i18n, onLinkClick }) => (
    <p className="account-help">
        {i18n.ACCOUNT_HELP_TEXT}
        <LocalizedNavLink
            to={`${PATH.FAQ_PATH}${FAQ_ID_ACCOUNT_CREATION ? `#${FAQ_ID_ACCOUNT_CREATION}` : ''}`}
            title={i18n.ACCOUNT_HELP_LINK_TITLE}
            onClick={onLinkClick}>
            {i18n.ACCOUNT_HELP_LINK}
        </LocalizedNavLink>
    </p>
);

AccountHelpComponent.propTypes = {
    onLinkClick: PropTypes.func
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.AUTHENTICATION
});

export default connect(mapStateToProps)(AccountHelpComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/accounthelp/AccountHelpComponent.js